<!-- NAVBAR -->
<nav [class.scrolled]="scrolled">
  <a routerLink="/" class="nav-brand">
    <img class="nav-logo" src="assets/logo-rogledi.svg" alt="Rogledi" width="36" height="36">
    <span class="nav-name">Rogledi</span>
  </a>
  <div class="nav-links">
    <a routerLink="/" class="nav-link">← Home</a>
    <a routerLink="." fragment="contatti" class="nav-link">✉️ Contatti</a>
  </div>
</nav>

<!-- HERO -->
<div class="hero">
  <div class="hero-eyebrow"><span></span> Integrazioni enterprise · SOAP · MTOM/XOP</div>
  <h1>Integrazioni SOAP-MTOM<br><em>per allegati di grandi dimensioni</em></h1>
  <p class="hero-sub">Web service SOAP-MTOM in PHP. Con allegati binari da centinaia di megabyte, codice nativo, no dipendenze.</p>
  <div class="hero-ctas">
    <a routerLink="." fragment="contatti" class="btn-primary">Parliamo della tua integrazione</a>
    <a routerLink="." fragment="caso-studio" class="btn-ghost">Vedi un caso reale</a>
  </div>

  <!-- Schema del flusso: committente → messaggio MTOM → servizio -->
  <div class="hero-card-wrap">
    <div class="flow">
      <div class="flow-node">
        <div class="flow-icon g-info">🏦</div>
        <div class="flow-title">Sistema del committente</div>
        <div class="flow-sub">WSDL imposto, tracciati rigidi</div>
      </div>
      <div class="flow-arrow">
        <div class="flow-msg">
          <div class="flow-part xml">&lt;soap:Envelope&gt;</div>
          <div class="flow-part bin">perizia.pdf · 148 MB</div>
          <div class="flow-part bin">foto.zip · 62 MB</div>
        </div>
        <div class="flow-label">multipart/related · MTOM</div>
      </div>
      <div class="flow-node">
        <div class="flow-icon g-primary">⚙️</div>
        <div class="flow-title">Il tuo servizio</div>
        <div class="flow-sub">Streaming su disco, RAM costante</div>
      </div>
    </div>
  </div>
</div>

<!-- PROBLEMI -->
<section id="problemi">
  <div class="container">
    <div class="section-eyebrow">Ti riconosci?</div>
    <h2 class="section-title">I problemi tipici<br>delle integrazioni SOAP</h2>
    <p class="section-sub">SOAP non è più di moda, ma banche, assicurazioni e pubblica amministrazione lo usano ancora ovunque. E quando qualcosa si rompe, pochi sanno dove mettere le mani.</p>
    <div class="features-grid">
      <div class="feature-card">
        <div class="feature-icon g-warning">📎</div>
        <h3>Allegati che fanno crollare il server</h3>
        <p>File grandi in base64 dentro l'XML saturano la memoria, superano i limiti del parser e mandano in timeout le chiamate.</p>
      </div>
      <div class="feature-card">
        <div class="feature-icon g-info">🧩</div>
        <h3>MTOM non supportato</h3>
        <p>Il committente invia messaggi multipart MTOM/XOP, ma il SoapServer nativo di PHP non li sa leggere.</p>
      </div>
      <div class="feature-card">
        <div class="feature-icon g-primary">📐</div>
        <h3>Tracciati rigidi</h3>
        <p>Campi a lunghezza fissa, codifiche obbligate, validazioni imposte dall'altra parte: un errore e il messaggio viene rifiutato.</p>
      </div>
      <div class="feature-card">
        <div class="feature-icon g-success">🕳️</div>
        <h3>Integrazioni che nessuno conosce più</h3>
        <p>Il servizio funziona da anni, chi l'ha scritto non c'è più e ora va modificato o ha smesso di rispondere.</p>
      </div>
    </div>
  </div>
</section>

<!-- SERVIZI -->
<div class="band">
  <div class="band-inner">
    <div class="section-eyebrow">Cosa faccio</div>
    <h2 class="section-title">Dal WSDL al servizio in produzione</h2>
    <div class="services">
      <div class="service">
        <div class="service-num">01</div>
        <div>
          <h4>Server e client SOAP in PHP</h4>
          <p>Implemento il servizio che il committente si aspetta, partendo dal suo WSDL e dai messaggi di esempio, oppure il client che chiama il suo.</p>
        </div>
      </div>
      <div class="service">
        <div class="service-num">02</div>
        <div>
          <h4>Allegati MTOM/XOP in streaming</h4>
          <p>Ricezione di allegati binari pesanti senza caricarli in memoria: il messaggio viene letto a blocchi e ogni file finisce direttamente su disco.</p>
        </div>
      </div>
      <div class="service">
        <div class="service-num">03</div>
        <div>
          <h4>Mappatura dei tracciati</h4>
          <p>Conversione tra i tracciati del committente e il tuo database, con validazione e cast dei campi prima che i dati entrino nel sistema.</p>
        </div>
      </div>
      <div class="service">
        <div class="service-num">04</div>
        <div>
          <h4>Diagnosi e manutenzione</h4>
          <p>Analisi di integrazioni esistenti che danno errori, rallentano o vanno estese: capisco cosa fanno e le rimetto in carreggiata.</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- CASO STUDIO -->
<section id="caso-studio">
  <div class="container case">
    <div class="case-text">
      <div class="section-eyebrow">Caso reale</div>
      <h2 class="section-title">Perizie immobiliari<br>scambiate con le banche</h2>
      <p class="section-sub">Ho progettato e scritto una piattaforma di gestione delle perizie immobiliari, in uso presso società di valutazione che lavorano per conto degli istituti di credito.</p>
      <ul class="case-list">
        <li><strong>Server SOAP</strong> che riceve gli incarichi dai sistemi bancari e restituisce le perizie nei tracciati richiesti.</li>
        <li><strong>Decoder MTOM scritto da zero</strong>, perché quello di PHP non esiste: legge il messaggio a blocchi da 1 MB e tiene in memoria solo l'envelope.</li>
        <li><strong>Allegati oltre i 150 MB</strong> per singolo messaggio, senza alzare <code>memory_limit</code> e senza incappare nei limiti del parser XML.</li>
        <li><strong>Motore dati</strong> che valida e converte ogni campo secondo le specifiche del committente, lunghezze fisse comprese.</li>
      </ul>
    </div>
    <div class="code-card">
      <div class="code-head">
        <span class="dot r"></span><span class="dot y"></span><span class="dot g"></span>
        <span class="code-file">mtom-stream.php · schema semplificato</span>
      </div>
      <pre><code>{{ mtomSnippet }}</code></pre>
    </div>
  </div>
</section>

<!-- NUMERI -->
<section class="stats-section">
  <div class="container">
    <div class="stats-grid">
      <div class="stat-card">
        <div class="stat-num">150 MB+</div>
        <div class="stat-label">Allegati gestiti in un singolo messaggio SOAP</div>
      </div>
      <div class="stat-card">
        <div class="stat-num">1 MB</div>
        <div class="stat-label">Memoria per blocco letto, qualunque sia la dimensione del file</div>
      </div>
      <div class="stat-card">
        <div class="stat-num">PHP</div>
        <div class="stat-label">Codice nativo, senza dipendenze da servizi esterni</div>
      </div>
    </div>
  </div>
</section>

<!-- COME LAVORO -->
<div class="band">
  <div class="band-inner">
    <div class="section-eyebrow">Come lavoro</div>
    <h2 class="section-title">Quattro passaggi, nessuna sorpresa</h2>
    <div class="steps">
      <div class="step">
        <div class="step-num">1</div>
        <h4>Mi mandi il materiale</h4>
        <p>WSDL, documentazione del committente e, se li hai, messaggi di esempio o log degli errori.</p>
      </div>
      <div class="step">
        <div class="step-num">2</div>
        <h4>Analisi e preventivo</h4>
        <p>Ti dico cosa serve, quanto tempo richiede e quanto costa, prima di iniziare.</p>
      </div>
      <div class="step">
        <div class="step-num">3</div>
        <h4>Sviluppo e test</h4>
        <p>Il servizio viene provato con messaggi reali, allegati pesanti compresi, prima di andare in produzione.</p>
      </div>
      <div class="step">
        <div class="step-num">4</div>
        <h4>Consegna</h4>
        <p>Codice tuo, documentato, con le istruzioni per gestirlo. Se serve, resto disponibile per la manutenzione.</p>
      </div>
    </div>
  </div>
</div>

<!-- FAQ -->
<section id="faq">
  <div class="container faq-wrap">
    <div class="section-eyebrow">Domande frequenti</div>
    <h2 class="section-title">Prima di scrivermi</h2>
    <div class="faq">
      <details>
        <summary>Dall'altra parte c'è Java o .NET: è un problema?</summary>
        <p>No. SOAP nasce proprio per far parlare sistemi diversi. Io lavoro sul lato PHP; il committente può usare qualunque tecnologia, purché rispetti il contratto definito dal WSDL.</p>
      </details>
      <details>
        <summary>Abbiamo già un'integrazione che dà errori: puoi solo sistemarla?</summary>
        <p>Sì. Spesso basta capire cosa non torna tra il messaggio inviato e quello atteso. Si parte dai log e da un paio di messaggi reali.</p>
      </details>
      <details>
        <summary>Gli allegati sono molto grandi. Fin dove si arriva?</summary>
        <p>Con la lettura in streaming la memoria usata non dipende dalla dimensione del file: il limite diventa lo spazio su disco e la durata massima della richiesta impostata sul server.</p>
      </details>
      <details>
        <summary>Lavori anche su REST?</summary>
        <p>Sì, ma questa pagina parla di SOAP perché è lì che di solito le aziende restano senza qualcuno che sappia mettere le mani sul codice.</p>
      </details>
    </div>
  </div>
</section>

<!-- CONTATTI -->
<div class="cta-section" id="contatti">
  <h2>Raccontami la tua integrazione.</h2>
  <p>Con chi devi parlare, cosa si scambia e dove si blocca. Ti rispondo con una prima valutazione.</p>

  <form class="contact-form" (submit)="sendContact($event)">
    <!-- honeypot: nascosto agli umani, compilato dai bot -->
    <input name="website" autocomplete="off" tabindex="-1" aria-hidden="true" style="position:absolute;left:-9999px;width:1px;height:1px;overflow:hidden" />
    <input    [(ngModel)]="contactName"  name="name"    placeholder="Nome e azienda"   maxlength="100"  required />
    <input    [(ngModel)]="contactEmail" name="email"   placeholder="Email di lavoro"  maxlength="150"  type="email" required />
    <input    [(ngModel)]="contactPhone" name="phone"   placeholder="Telefono (facoltativo)" maxlength="30" type="tel" />
    <textarea [(ngModel)]="contactMsg"   name="message" placeholder="Con quale sistema devi integrarti? Ci sono allegati? Cosa non funziona?" maxlength="2000" rows="5" required></textarea>
    <div class="contact-footer">
      @if (contactStatus === 'ok') {
        <span class="contact-ok">✦ Messaggio inviato! Ti rispondo a breve.</span>
      } @else if (contactStatus === 'error') {
        <span class="contact-err">✗ Errore nell'invio, riprova.</span>
      }
      <button type="submit" [disabled]="contactSending">
        {{ contactSending ? 'Invio in corso…' : 'Invia messaggio' }}
      </button>
    </div>
  </form>
</div>

<!-- FOOTER -->
<footer>
  <span>© 2026 Rogledi · Integrazioni SOAP e MTOM</span>
  <div class="footer-links">
    <a routerLink="/">Home</a>
    <a routerLink="." fragment="contatti">Contatti</a>
    <a routerLink="/privacy">Privacy Policy</a>
  </div>
</footer>
